import ContainerSimple from "../../../Components/ContainerSimple";
import InputAdmin from "../../../Components/InputFields/InputAdmin";
import Custom from "../../../Components/Buttons/Custom";
import MultipleSelectAdmin from "../../../Components/InputFields/MultipleSelectAdmin";
import { useEffect, useState } from "react";
import { API_BASE_URL } from "../../../config/api";

export default function AnnouncementModalEdit({ onClose, notif }) {
  const [selectedChallenge, setSelectedChallenge] = useState("");

  const [editData, setEditData] = useState(null);

  const handleEdit = async () => {
    try {
      let response = await fetch(
        `${API_BASE_URL}/api/v0/notifications/admin/announcements/${notif?.uuid}/`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
          body: JSON.stringify({
            title: editData.title,
            description: editData.description,
            display_to_users: editData.display_to_users,
          }),
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          window.location.href = "/signin";
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}/api/v0/notifications/admin/announcements/${notif?.uuid}/`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
            body: JSON.stringify({
              title: editData.title,
              description: editData.description,
              display_to_users: editData.display_to_users,
            }),
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      onClose();
      window.location.reload();
    } catch (error) {
      console.error("Error fetching account data:", error);
    }
  };

  useEffect(() => {
    if (notif) {
      // Populate form fields with notif data
      setEditData({
        id: notif.uuid,
        title: notif.title,
        description: notif.description,
        display_to_users: notif.status === "active",
      });
    }
  }, [notif]);

  return (
    <ContainerSimple>
      <div className="w-full flex gap-12">
        <InputAdmin
          label="وضعیت"
          id="type"
          name="type"
          type="select"
          selectOptions={["نمایش", "عدم نمایش"]}
          selectPlaceHolder="انتخاب کنید"
          value={editData?.display_to_users ? "نمایش" : "عدم نمایش"}
          onChange={(e) => {
            if (e.target.value === "نمایش") {
              setEditData({ ...editData, display_to_users: true });
            } else {
              setEditData({ ...editData, display_to_users: false });
            }
          }}
        />
        <div className="w-full"></div>
      </div>
      <div className="w-full flex gap-12">
        <InputAdmin
          label="عنوان اعلان"
          id="type"
          name="type"
          type="text"
          value={editData?.title}
          onChange={(e) => setEditData({ ...editData, title: e.target.value })}
        />
      </div>
      <div className="w-full flex flex-col gap-2.5">
        <label
          htmlFor="notes"
          className="text-sm font-normal text-zi-text-light/50 dark:text-zi-text-dark/50"
        >
          توضیحات اعلان
        </label>
        <textarea
          id="notes"
          name="notes"
          value={editData?.description}
          onChange={(e) =>
            setEditData({ ...editData, description: e.target.value })
          }
          className={`w-full h-40 leading-loose resize-none rounded-lg py-1 px-2.5 border border-zi-border-light dark:border-zi-border-dark text-zi-text-light dark:text-zi-text-dark appearance-none bg-transparent`}
        ></textarea>
      </div>
      <div className="w-full flex gap-2.5 mt-6">
        <Custom
          text="انصراف و بستن"
          svg_name="xMark"
          svgClassName="stroke-zi-text-light dark:stroke-zi-text-dark"
          href=""
          className="!rounded-lg !p-2.5 w-full text-zi-text-light dark:text-zi-text-dark ring-1 ring-zi-border-dark bg-transparent"
          onClick={onClose}
        />
        <Custom
          text="ذخیره تغییرات"
          svg_name="checkMark"
          svgClassName="stroke-zi-text-dark"
          href=""
          className="!rounded-lg !p-2.5 w-full text-zi-text-dark bg-zi-gradient-button-blue"
          textShadow={true}
          svgShadow={true}
          onClick={handleEdit}
        />
      </div>
    </ContainerSimple>
  );
}
